import React from 'react';
import PropTypes from 'prop-types';

function BackArrowIcon({ color = 'black', width = 16, height = 15, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.17502 6.58328H15.3327V8.41662H4.17502L9.09202 13.3336L7.79585 14.6298L0.666016 7.49995L7.79585 0.370117L9.09202 1.66628L4.17502 6.58328Z"
        fill={color}
      />
    </svg>
  );
}

BackArrowIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default BackArrowIcon;
